export enum SectionTemplate {
    QuadImagesBottom = 1,
    DualImagesBottom = 2,
    TextOnly = 3,
    TripleImagesBottom = 4,
    SingleImageBottom = 5,
    SingleImageTop = 6,
    SingleImageRight = 7,
    DualTitleDescriptionPairs = 8,
    TripleTitleDescriptionPairs = 9,
    QuadTitleDescriptionPairs = 10,
    SingleTitleQuintupleDescription = 11,
    SingleTitleDescriptionAuthorPairs = 12,
    SingleTitleQuestionAnswerPairs = 13,
}

export enum SectionMode {
    Template = 'template',
    Edit = 'edit',
    View = 'view',
}
